"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _MerchandiseIds = require("self-service-api/constants/MerchandiseIds");

var _default = [_MerchandiseIds.PRODUCT_CMS_PROFESSIONAL, _MerchandiseIds.PRODUCT_CMS_ENTERPRISE];
exports.default = _default;
module.exports = exports.default;